import { MagnifyingGlassIcon } from '@phosphor-icons/react';

import classNames from '@/utils/classnames';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchInput({ value, onChange, placeholder = 'Search...', className }: SearchInputProps) {
  return (
    <div
      className={classNames(
        'flex h-10 items-center gap-2.5 rounded-xl border border-line bg-surface-3 px-3.5 focus-within:border-brand-border transition-colors shadow-sm',
        className,
      )}
    >
      <MagnifyingGlassIcon size={15} className="text-fg-muted" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex-1 bg-transparent text-xs text-fg placeholder:text-fg-muted outline-none"
      />
    </div>
  );
}
